import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';
import { Consignee, ConsigneeAddress } from '../models/order/consignee.model';
import { BuyersApiService } from './buyers-api.service';

@Injectable({
  providedIn: 'root'
})
export class ConsigneesApiService {

  $loading = new BehaviorSubject<boolean>(false);
  loading$ = this.$loading.pipe(shareReplay(1));
  consignees$: Observable<Consignee[]> = this.buyersApiService.selectedId$.pipe(
    switchMap(id => id ? this.fetch(id) : of(undefined)),
    shareReplay(1)
  );
  consigneesByAddress$: Observable<ConsigneeAddress[]> = this.consignees$.pipe(
    map(consignees =>
      // generate duplicate objects, one per address
      consignees.flatMap(consignee =>
        consignee.addresses.map(address => Object.assign({}, consignee, { address }) as ConsigneeAddress)
      )
    ),
    shareReplay(1)
  );

  constructor(
    private http: HttpClient,
    private buyersApiService: BuyersApiService,
  ) {
  }

  fetch(id: number) {
    this.$loading.next(true);
    return this.http.get<Consignee[]>(`${env.apiPath}/consignees/${id}`)
      .pipe(
        catchError(() => of([])),
        tap(() => this.$loading.next(false)),
      );
  }

}
